import script from "./indexComposition.vue?vue&type=script&setup=true&lang=js"
export * from "./indexComposition.vue?vue&type=script&setup=true&lang=js"

import "./indexComposition.vue?vue&type=style&index=0&id=f9aa76ac&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\dslx464\\Desktop\\workspace\\chatgpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9aa76ac"]])

export default __exports__